import { BaseFilePickerInputEl } from './BaseFilePicker.styled';
import type { BaseFilePickerInputStateAndHandlers } from './useBaseFilePickerInputStateAndHandlers';

type Props = {
  name: string;
  required: boolean;
  qaId: string;
  ariaLabel: string | null;
  accept: string | null;
  disabled: boolean;
  stateAndHandlers: BaseFilePickerInputStateAndHandlers;
};

export function BaseFilePickerInput({
  name,
  qaId,
  required,
  ariaLabel,
  accept,
  disabled,
  stateAndHandlers,
}: Props) {
  return (
    <BaseFilePickerInputEl
      name={name}
      type="file"
      // The local file selected by the user is not stored as state.
      // We upload it immediately and use the uploaded file instead
      value=""
      aria-label={ariaLabel ?? undefined}
      required={required}
      disabled={disabled}
      data-qa-id={`${qaId}-hidden-input`}
      accept={accept ?? undefined}
      onChange={stateAndHandlers.onChange}
      onMouseEnter={stateAndHandlers.onMouseEnter}
      onMouseLeave={stateAndHandlers.onMouseLeave}
      onDragEnter={stateAndHandlers.onDragEnter}
      onDragEnd={stateAndHandlers.onDragEnd}
      onDragLeave={stateAndHandlers.onDragEnd}
      onFocus={stateAndHandlers.onMouseEnter}
      onBlur={stateAndHandlers.onMouseLeave}
    />
  );
}
